import React, { useState } from "react";
import "./ConsultantPage.css";

const ConsultantPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    level: "",
  });

  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      const response = await fetch("https://overseas-backend-1-548y.onrender.com/api/consultation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Submission failed");
      }

      setStatus({ loading: false, success: true, error: null });
      setFormData({ name: "", email: "", phone: "", country: "", level: "" });
    } catch (error) {
      console.error("Error submitting consultation form:", error);
      setStatus({ loading: false, success: false, error: error.message });
    }
  };

  return (
    <div className="consultant-page-wrapper">
      <div className="consultant-hero">
        <h1>Speak With Our Experts</h1>
        <p>Get personalized guidance for your study abroad journey.</p>
      </div>

      <div className="consultant-form-container">
        <h2>Book a Free Consultation</h2>
        <form className="consultant-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" required />
          </div>

          <div className="form-group">
            <label>Destination Country</label>
            <select name="country" value={formData.country} onChange={handleChange} required>
              <option value="">Select Country</option>
              <option>USA</option>
              <option>Canada</option>
              <option>Australia</option>
              <option>UK</option>
              <option>Germany</option>
              <option>New Zealand</option>
              <option>Ireland</option>
            </select>
          </div>

          <div className="form-group">
            <label>Level of Study</label>
            <select name="level" value={formData.level} onChange={handleChange} required>
              <option value="">Select Level</option>
              <option>Undergraduate</option>
              <option>Postgraduate</option>
              <option>PhD</option>
              <option>Diploma</option>
            </select>
          </div>

          <button type="submit" className="submit-btn" disabled={status.loading}>
            {status.loading ? "Submitting..." : "Submit Request"}
          </button>

          {status.success && <p className="success-msg">✅ Request submitted successfully!</p>}
          {status.error && <p className="error-msg">❌ {status.error}</p>}
        </form>
      </div>
    </div>
  );
};

export default ConsultantPage;
